var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApteanEdiWordmarkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.59 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.89,161.25h8.64l7.83,32.62h-7.29L277.72,187h-7.38L269,193.87H262.1Zm1.35,21.24h5.58L274,168.18Z",
    transform: "translate(-262.1 -161.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.68,183.3c0,7.38-2.25,11.11-7.52,11.11a6.1,6.1,0,0,1-5.71-3.6v10.94h-6.93V169.66h6.93v2.84a6.1,6.1,0,0,1,5.71-3.6c5.27,0,7.52,3.73,7.52,11.11Zm-9.86-9.72c-3,0-3.6,3.1-3.6,8.1s.59,8,3.6,8c2.57,0,2.79-2.61,2.79-7.47v-1.21C301.61,176.19,301.39,173.58,298.82,173.58Z",
    transform: "translate(-262.1 -161.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.86,187.35V173.94H310v-4.28h2.88v-6.57h6.93v6.57h4.1v4.28h-4.1v12.73c0,2.48.59,2.93,2.34,2.93h1.76v4.27h-4.95C314.17,193.87,312.86,192.16,312.86,187.35Z",
    transform: "translate(-262.1 -161.25)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.36,183.61v-4c0-7,3.2-10.71,9.9-10.71,7.29,0,9.68,3.91,9.68,12.15v1.3H333.2v.36c0,4.64.36,7.25,3,7.25,1.71,0,3-.68,3-4.1v-.18h6.43v.23c0,6.57-4.86,8.5-9.54,8.5C329.33,194.41,326.36,190.5,326.36,183.61Zm6.84-5h6.39v-.4c0-3.56-.72-5-3.19-5s-3.2,1.48-3.2,5Z",
    transform: "translate(-262.1 -161.25)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.32,187.62v-.27c0-4,2.16-6.12,11.88-9.09v-1.35c0-2.52-.67-3.78-2.61-3.78s-2.92,1.26-2.92,3.73v.41h-6v-.41c0-4.68,3.55-8,9.27-8s9.13,1.93,9.09,8.59L367,186a47.2,47.2,0,0,0,.36,7.87H361.1l-.18-3.24c-1.08,2.52-3.15,3.78-6.12,3.78C350.89,194.41,348.32,191.8,348.32,187.62Zm12.06-4.05V182c-4.95,1.4-5.22,2.7-5.22,4.59V187c0,1.84.68,3.1,2.25,3.1C359.21,190.09,360.38,188.52,360.38,183.57Z",
    transform: "translate(-262.1 -161.25)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.64,193.87V169.66h6.93v2.84c1.13-2.52,3.2-3.6,6-3.6,4.32,0,5.8,2.92,5.8,8.23v16.74h-6.93V178.48c0-2.61-.09-4.68-2-4.68-2.75,0-2.84,3.2-2.84,7v13.05Z",
    transform: "translate(-262.1 -161.25)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.69,161.25h18v5.22h-10.8v8.1h9.85v5.22h-9.85v8.86h10.8v5.22h-18Z",
    transform: "translate(-262.1 -161.25)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.07,161.25h7.74c9.4,0,13.86,2.43,13.86,14.53v3.78c0,11.88-4.46,14.31-13.86,14.31h-7.74Zm8.05,27.81c5.31,0,5.94-1.4,5.94-10.49v-2.11c0-9-.63-10.44-5.94-10.44h-.9v23Z",
    transform: "translate(-262.1 -161.25)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.54,161.25h7.15v32.62h-7.15Z",
    transform: "translate(-262.1 -161.25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApteanEdiWordmarkWhite);
export default __webpack_public_path__ + "static/media/ApteanEDIWordmarkWhite.8b3eca6586f44dcb7d8e010d50e28da2.svg";
export { ForwardRef as ReactComponent };